import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('lingua_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ── AUTH ──
export const register = (email, username, password) =>
  api.post('/auth/register', { email, username, password });
export const login = (email, password) =>
  api.post('/auth/login', { email, password });
export const getMe = () => api.get('/auth/me');
export const updateUsername = (username) =>
  api.put('/auth/me/username', { username });
export const changePassword = (current_password, new_password) =>
  api.put('/auth/me/password', { current_password, new_password });
export const forgotPassword = (email) =>
  api.post('/auth/forgot-password', { email });
export const resetPassword = (token, new_password) =>
  api.post('/auth/reset-password', { token, new_password });

// ── TRANSLATE ──
export const translate = (text, source_lang, target_lang) =>
  api.post('/translate/', { text, source_lang, target_lang });
export const getExamples = (word, lang, cefr_level) =>
  api.get('/translate/examples', { params: { word, lang, cefr_level } });

// ── DECKS ──
export const getDecks = () => api.get('/decks/');
export const getPublicDecks = () => api.get('/decks/public');

export const copyPublicDeck = (deckId) => api.post(`/decks/public/${deckId}/copy`);

export const createDeck = (title, description, is_public) =>
  api.post('/decks/', { title, description, is_public });
export const updateDeck = (deck_id, data) =>
  api.put(`/decks/${deck_id}`, data);
export const deleteDeck = (deck_id) => api.delete(`/decks/${deck_id}`);
export const addFlashcard = (deck_id, data) =>
  api.post(`/decks/${deck_id}/flashcards`, { ...data, deck_id });
export const getFlashcards = (deck_id) =>
  api.get(`/decks/${deck_id}/flashcards`);
export const updateFlashcard = (deck_id, card_id, data) =>
  api.put(`/decks/${deck_id}/flashcards/${card_id}`, data);
export const deleteFlashcard = (deck_id, card_id) =>
  api.delete(`/decks/${deck_id}/flashcards/${card_id}`);
export const reviewFlashcard = (flashcard_id, quality) =>
  api.post('/decks/review', { flashcard_id, quality });

// ── GROUPED ──
export const authAPI = {
  register: (email, username, password) => register(email, username, password),
  login: (email, password) => login(email, password),
  me: () => getMe(),
  updateUsername: (username) => updateUsername(username),
  changePassword: (current, next) => changePassword(current, next),
  forgotPassword: (email) => forgotPassword(email),
  resetPassword: (token, password) => resetPassword(token, password),
};

export const translateAPI = {
  translate: (text, source_lang, target_lang) => translate(text, source_lang, target_lang),
  getExamples: (word, lang, cefr_level) => getExamples(word, lang, cefr_level),
};

export const decksAPI = {
  list: () => getDecks(),
  create: (title, description, is_public) => createDeck(title, description, is_public),
  update: (deck_id, data) => updateDeck(deck_id, data),
  delete: (deck_id) => deleteDeck(deck_id),
  addFlashcard: (deck_id, data) => addFlashcard(deck_id, data),
  getFlashcards: (deck_id) => getFlashcards(deck_id),
  updateFlashcard: (deck_id, card_id, data) => updateFlashcard(deck_id, card_id, data),
  deleteFlashcard: (deck_id, card_id) => deleteFlashcard(deck_id, card_id),
  review: (flashcard_id, quality) => reviewFlashcard(flashcard_id, quality),
  getPublic: () => getPublicDecks(),
  copy: (deckId) => copyPublicDeck(deckId),
};

export default api;
